<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Dobry Agent'" [name]="'Autorzy'"></app-breadcrumb>
<div class="author-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >
    <mat-form-field class="author-list-filter">
      <mat-label>Autor</mat-label>
      <input matInput placeholder="Jan Kowalski" name="context" [(ngModel)]="initialFilters.context">
    </mat-form-field>

    <app-datepicker
      class="author-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="author-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <mat-form-field
      appearance="standard"
      class="author-list-filter">
      <mat-label>Aktywny</mat-label>
      <mat-select [(ngModel)]="initialFilters.active" name="active">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field
      appearance="standard"
      class="blog-tag-list-filter">
      <mat-label>Archiwum</mat-label>
      <mat-select [(ngModel)]="initialFilters.deleted" name="deleted">
        <mat-option [value]="null">Bez archiwum</mat-option>
        <mat-option [value]="'1'">Tylko archiwum</mat-option>
        <mat-option value="all">Wszyscy</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div >
    <div class="add-button">
      <a  [routerLink]="['/blog-dobry-agent/autorzy/dodaj']">
        <button  [disabled]="!(userPermissions | async).dobry_agent.write" (click)="add()"  mat-raised-button color="accent" >
          <mat-icon>add</mat-icon> <span> Dodaj autora</span>
        </button>
      </a>
    </div>

    <div class="author-list-buttons">

      <button (click)="filter()" mat-raised-button color="primary">
        <mat-icon>search</mat-icon> <span> Szukaj</span>
      </button>


      <button (click)="resetFilters()" mat-raised-button color="warn">
        <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
      </button>
    </div>

  </div>

  <table mat-table [dataSource]="authors" matSort (matSortChange)="sortChanged($event)" >
    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Imię i nazwisko</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.deleted">
          <div class="statusChange-flex-container">
            <mat-chip-list>
              <mat-chip class="statusChange-button-container" matTooltip="Archiwum">A</mat-chip>
            </mat-chip-list>
            <img *ngIf="element.imagePath" [src]="element.imagePath"  alt="element.altImage"/>
            {{element.firstName}} {{element.lastName}}
          </div>
        </ng-container>
        <ng-container *ngIf="!element.deleted">
        <a class="default-link featured-image" [routerLink]="['szczegoly', element.uuid]">
          <img *ngIf="element.imagePath" [src]="element.imagePath"  alt="element.altImage"/>
          {{element.firstName}} {{element.lastName}}
        </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="description">Opis</th>
      <td mat-cell *matCellDef="let element">
        {{element.description}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="createdAt"> Data utworzenia</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="agent">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="agent"> Użytkownik ASF24</th>
      <td mat-cell *matCellDef="let element">
        <div class="statusChange-flex-container">
        <ng-container *ngIf="element.agent?.user24Id">
          <mat-chip-list>
            <mat-chip class="statusChange-button-container chip-yellow" selected matTooltip="Agent">O</mat-chip>
          </mat-chip-list>
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.agent?.user24Id]">{{element.agent?.firstName +' '+ element.agent?.lastName}}</a>
        </ng-container>
        <ng-container *ngIf="element.user24Id && !element.agent">
          <mat-chip-list>
            <mat-chip class="statusChange-button-container" matTooltip="Użytkownik">U</mat-chip>
          </mat-chip-list>
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.user24Id]">{{element?.firstName +' '+ element?.lastName}}</a>
        </ng-container>
        </div>
      </td>
    </ng-container>


    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="active"> Status</th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="!element.active" mat-stroked-button [ngClass]="'disabled-button'">Nieaktywny</button>
        <button *ngIf="element.active" mat-raised-button  [ngClass]="'positive-button'">Aktywny</button>
      </td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="(userPermissions | async).dobry_agent.write">
          <div class="button-actions">
            <button *ngIf="element.deleted"
                    (click)="restore(element)" mat-stroked-button>
              <mat-icon>history</mat-icon>
              <span> Przywróć z archiwum</span>
            </button>
            <button *ngIf="!element.deleted"
                    (click)="deleteWeak(element.uuid)" mat-stroked-button>
              <mat-icon>archive</mat-icon>
              <span> Przenieś do archiwum</span>
            </button>
            <button
              (click)="delete(element)" mat-stroked-button color="warn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
